import { Component, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import {
    AuthenticationStrengthPolicy,
    ConditionalAccessPolicy,
    NamedLocation,
} from '@microsoft/microsoft-graph-types-beta';
import { Store } from '@ngrx/store';
import { BehaviorSubject, filter, Observable, sample } from 'rxjs';
import { BaseComponent } from '../../../base/base.component';
import { initCapGenericForm } from '../shared/cap-generic-form';
import { createGenericCapPolicySchema } from '../shared/cap-generic-schema';
import { client } from 'projects/angular-clarity/src/app/stores/client';
import { GenericCapSchema_Data } from 'projects/angular-clarity/src/app/modules/sway/models/baseline-schemas/generic-cap-schema-model';

@Component({
    selector: 'app-baseline',
    templateUrl: './baseline.component.html',
    styleUrls: ['./baseline.component.scss', '../../../styles/baseline-style.scss'],
})
export class BaselineComponent extends BaseComponent implements OnInit, OnChanges, OnDestroy {
    schemaFunc = createGenericCapPolicySchema;
    schema$: BehaviorSubject<GenericCapSchema_Data>;
    policy$: BehaviorSubject<ConditionalAccessPolicy> = new BehaviorSubject(null);

    authenticationStrengthPolicies$: Observable<AuthenticationStrengthPolicy[]>;
    namedLocations$: Observable<NamedLocation[]>;

    constructor(
        private fb: FormBuilder,
        private store: Store<any>,
    ) {
        super();
    }

    ngOnChanges(changes: SimpleChanges): void {
        console.log(this.errorsString, 'error string');
    }

    ngOnInit(): void {
        const authenticationStrengthPoliciesStatus$ = this.store
            .select(client(this.tenant_id).graph.authenticationMethods.status)
            .pipe(filter((res) => res.loaded));

        this.authenticationStrengthPolicies$ = this.store
            .select(client(this.tenant_id).graph.authenticationStrengthPolicy.all)
            .pipe(sample(authenticationStrengthPoliciesStatus$));

        const namedLocationsStatus$ = this.store
            .select(client(this.tenant_id).graph.namedLocations.status)
            .pipe(filter((res) => res.loaded));

        this.namedLocations$ = this.store
            .select(client(this.tenant_id).graph.namedLocations.all)
            .pipe(sample(namedLocationsStatus$));

        this.form = this.initForm(this.baseline.schema, this.baseline.name);
        this.schema$ = new BehaviorSubject(this.baseline.schema);
        // TODO: remove this when the schema not needed to be subject
    }

    onBaselineChange(e) {
        this.baselineChange.next(e);
    }

    initForm(schema, name) {
        return initCapGenericForm(schema, this.fb, name);
    }

    onBaselineErrorChange(e) {
        this.baselineErrorChange.next(e);
    }
}
